import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select';

import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import RootContext from '../../../components/Context/RootContext';
import { ReactComponent as CloseBtn } from './../../../assets/icons/close.svg';

const SelectCompany = () => {

    const navigate = useNavigate();
    const rootContextValue = useContext(RootContext);

    const [isLoad, setIsLoad] = useState(false);
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);

    // Own Company List
    useEffect(() => {

        PostLoginGetApi("company/lists/switch", "", 1)
            .then((responseJSON) => {
                let response = JSON.parse(JSON.stringify(responseJSON));

                if (response.status === 1) {
                    let responseData = JSON.parse(JSON.stringify(response.data));

                    if (responseData.code === 200) {
                        const companies = responseData.data;
                        setCompanyList(companies);

                        // Set default selected from localStorage
                        const savedId = window.localStorage.getItem("CompanyId");
                        if (savedId) {
                            const found = companies.find(c => c.id === parseInt(savedId));
                            if (found) {
                                setSelectedCompany({
                                    value: found.id,
                                    label: found.name
                                });
                            }
                        }
                    }
                }

                setIsLoad(true);
            })
            .catch((err) => {
                console.log(err);
            });

    }, []);

    const handleChange = (selected) => {
        setSelectedCompany(selected);

        window.localStorage.setItem('CompanyId', selected.value);
        toast.success("Selected company has been set as default.");
        rootContextValue.forceUpdate('viewProfile');
        navigate('/dashboard/home');
    };

    const companyOptions = companyList.map((data) => ({
        value: data.id,
        label: data.name
    }));

    return (
        <div className="font-medium min-h-[100vh] w-full custom-container-left custom-scroll-auto">
            <div className="pb-[60px]">
                <header className="flex justify-between items-center p-4 border-b-2 border-dark-white mb-[60px]">
                    {(window.localStorage.getItem("CompanyId") === null || window.localStorage.getItem("CompanyId") === "") ?
                        <Link to="/dashboard/logout"><CloseBtn /></Link>
                        :
                        <Link to="/dashboard"><CloseBtn /></Link>
                    }
                    <p className="text-xl text-black text-center">Choose Company</p>
                    <div></div>
                </header>

                <main className="max-w-3xl m-auto mb-[60px]">
                    <div className="flex justify-center">
                        <form className="w-full">

                            <h3 className="text-xl -mb-[5px]">
                                Before proceeding, please select a company,
                            </h3>

                            <div className="py-2 mt-1 relative mb-3">
                                {(companyList.length > 0) ?
                                    <Select
                                        options={companyOptions}
                                        value={selectedCompany}
                                        onChange={handleChange}
                                        placeholder="Select Company"
                                        isSearchable={true} // 🔥 key change
                                        classNamePrefix="react-select"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                boxShadow: 'none',
                                                borderColor: '#e5e7eb',
                                                cursor: 'pointer' // 👈 normal pointer instead of text cursor
                                            })
                                        }}
                                    />
                                    :
                                    (isLoad && <p className='text-md'>No company available for switch</p>)
                                }
                            </div>

                            <p className='mt-2 text-sm text-justify'>
                                If you encounter any issues or need further assistance, please refer to the provided user guide or contact our support team or KAM directly for help.
                            </p>

                            <Link
                                to={"/home"}
                                className="text-white font-semibold bg-primary px-10 py-2 mb-3 mt-5 rounded cursor-pointer hover:bg-brand-dark float-right"
                            >
                                SKIP NOW
                            </Link>

                        </form>
                    </div>
                </main>
            </div>

            <style>{`
                * :disabled {
                    background-color: #F5F5F5 !important;
                }
            `}</style>
        </div>
    );
};

export default SelectCompany;